module.exports = __webpack_public_path__ + "5ce637a8a44f2542497a621783dbc2fe.svg";